"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForm = void 0;
var react_1 = require("react");
var isEmail_1 = require("./methods/validators/isEmail");
var isLengthAbove_1 = require("./methods/validators/isLengthAbove");
var isCustomRegex_1 = require("./methods/validators/isCustomRegex");
var isLengthUnder_1 = require("./methods/validators/isLengthUnder");
var isCustomValidator_1 = require("./methods/validators/isCustomValidator");
var isFileSmallerThan_1 = require("./methods/validators/isFileSmallerThan");
var isFileMime_1 = require("./methods/validators/isFileMime");
var displayerSpacesToThousands_1 = require("./methods/displayers/displayerSpacesToThousands");
var useFormReducer_1 = require("./reducer/useFormReducer");
var getInitialForm_1 = require("./methods/getInitialForm");
var reset_1 = require("./methods/reset");
var update_1 = require("./methods/update");
var setForm_1 = require("./methods/setForm");
var useForm = function (initialForm) {
    var _a = react_1.useReducer(useFormReducer_1.useFormReducer(initialForm), initialForm), form = _a[0], updateForm = _a[1];
    var methods = {
        reset: reset_1.reset(updateForm),
        getInitialForm: getInitialForm_1.getInitialForm(initialForm),
        setForm: setForm_1.setForm(updateForm),
    };
    var validators = {
        isFileSmallerThan: isFileSmallerThan_1.isFileSmallerThan,
        isFileMime: isFileMime_1.isFileMime,
        isCustomValidator: isCustomValidator_1.isCustomValidator,
        isLengthAbove: isLengthAbove_1.isLengthAbove,
        isLengthUnder: isLengthUnder_1.isLengthUnder,
        isCustomRegex: isCustomRegex_1.isCustomRegex,
        isEmail: isEmail_1.isEmail,
    };
    var displayers = {
        displayerSpacesToThousands: displayerSpacesToThousands_1.displayerSpacesToThousands,
    };
    var formidable = __assign(__assign(__assign({}, methods), validators), displayers);
    return [form, update_1.update(updateForm), formidable];
};
exports.useForm = useForm;
//# sourceMappingURL=useForm.js.map